module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-45-min.fc8da94b.jpg";